<template>
    <div v-if="visible" class="modal-overlay">
        <div class="modal-content">
            <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null">
                <span class="text">{{ msgAlerta }}</span>
            </div>
            <form @submit.prevent="onSubmit">
                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">{{ edTitulo }}</label>
                        <textarea v-model="edJustificativa" :maxlength="edMaxlength" :required="edObrigatorio" rows="5" />
                    </div>
                </div>

                <div class="row-end">
                    <button type="button" class="btn-small btn-cancel" @click="closeModal">Voltar</button>
                    <button type="submit" class="btn-small btn-save">Confirmar</button>
                </div>
            </form>
        </div>
    </div>
</template>


<script setup>
import { ref } from 'vue';

const visible = ref(false);
const edJustificativa = ref('');
const edTitulo = ref('Justificativa');
const edMaxlength = ref(2000);
const edObrigatorio = ref(null);
const msgAlerta = ref(null);

let resolvePromise = null;

const show = ({
    titulo = 'Justificativa',
    maxlength = 2000,
    obrigatorio = true,
} = {}) => {
    edJustificativa.value = '';
    edTitulo.value = titulo;
    edMaxlength.value = maxlength;
    edObrigatorio.value = obrigatorio;
    visible.value = true;

    return new Promise((resolve) => {
        resolvePromise = resolve;
    });
};

const onSubmit = () => {
    const justificativa = edJustificativa.value.trim();

    if (edObrigatorio.value && !justificativa) {
        msgAlerta.value = `Campo de "${edTitulo.value}" é obrigatório`;
        return;
    }

    visible.value = false;

    if (resolvePromise) {
        resolvePromise({
            confirmado: true,
            justificativa: edJustificativa.value,
        });
    }

    resolvePromise = null;
};

const closeModal = () => {
    visible.value = false;

    if (resolvePromise) {
        resolvePromise({
            confirmado: false,
            justificativa: null,
        });
    }

    resolvePromise = null;
};

defineExpose({ show });
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 600px;
}
</style>
  